import { InjectionToken } from '@angular/core';

import { GoogleTagManagerConfig } from './google-tag-manager-config';

export const GOOGLE_TAG_MANAGER_CONFIG = new InjectionToken<GoogleTagManagerConfig>('google-tag-manager-configs');
export const GOOGLE_TAG_MANAGER_ID = new InjectionToken<string>('googleTagManagerId');
export const GOOGLE_TAG_MANAGER_MODE = new InjectionToken<'silent' | 'noisy'>('googleTagManagerMode');
export const GOOGLE_TAG_MANAGER_AUTH = new InjectionToken<string>('googleTagManagerAuth');
export const GOOGLE_TAG_MANAGER_PREVIEW = new InjectionToken<string>('googleTagManagerPreview');
export const GOOGLE_TAG_MANAGER_RESOURCE_PATH = new InjectionToken<string>('googleTagManagerResourcePath');
export const GOOGLE_TAG_MANAGER_CSP_NONCE = new InjectionToken<string>('googleTagManagerCSPNonce');
